import { Grid, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { theme } from 'config';

export const Container = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
});

export const TimesWrapper = styled(Grid)({
  display: 'flex',
  alignItems: 'center',

  [theme.breakpoints.down('sm')]: {
    marginBottom: '5px',
  },
});

export const Time = styled(Typography)({}, ({ actual }) => ({
  textDecoration: actual === 'true' ? 'line-through' : 'none',
  marginRight: actual === 'true' ? '5px' : '0',
}));

export const Destination = styled(Grid)({
  display: 'flex',
  alignItems: 'baseline',

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
});

export const City = styled(Typography)({
  marginRight: '5px',
});

export const Code = styled(Typography)({
  fontSize: '16px',
});
